import { Grid2 as MaterialGrid, Grid2TypeMap } from '@mui/material';
import type { OverridableComponent, OverrideProps } from '@mui/material/OverridableComponent';
import React, { forwardRef } from 'react';

export type GridProps<
  D extends React.ElementType = Grid2TypeMap['defaultComponent'],
  P = { component?: React.ElementType },
> = OverrideProps<Grid2TypeMap<P, D>, D>;

/**
 * The Grid
 *
 * @version [AIV]{version}[/AIV]
 * @author [SFP](https://gitlab.sfp.berlin/products/sparkasse.de/portals)
 * @see [https://styleguide.sparkasse.de/document/69#/komponenten/grid]
 */
const ForwardGrid = forwardRef<HTMLDivElement, GridProps>((props, ref) => {
  return (
    <MaterialGrid {...props} ref={ref}>
      {props.children}
    </MaterialGrid>
  );
});

ForwardGrid.displayName = 'Grid';

export const Grid = ForwardGrid as OverridableComponent<Grid2TypeMap>;
